import * as React from 'react';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
// import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { toast, Slide } from 'react-toastify';
import configAxios from '../service/configAxios';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';

export default function OurPlans() {

  const styles = {
    pricing: {
      padding: '120px 0',
      position: 'relative',
    },

    container: {
      width: '100%',
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 24px',
    },

    sectionHeader: {
      textAlign: 'center',
      marginBottom: '64px',
      maxWidth: '600px',
      marginLeft: 'auto',
      marginRight: 'auto',
    },

    textGradient: {
      background: 'linear-gradient(135deg, #ffffff, #A5E13B)', // Substituí var(--primary) pela sua cor verde
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
      fontWeight: 'inherit', // Para manter o peso do h2,
      lineHeight: 1.2,
      fontWeight: 700,
      fontSize: '2.5rem',
      marginBottom: '24px',
      letterSpacing: '-1px', // O valor negativo deve ser uma string '-1px'
      lineHeight: 1.2,
    },

    sectionHeader: {
      color: '#a0a5b5',
      fontSize: '1.1rem',
      marginBottom: '30px',
    },

    pricingGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: '44px',
      alignItems: 'center',
    },

    pricingCard: {
      background: '#151820',
      border: '1px solid #a0a5b555',
      borderRadius: '24px',
      padding: '40px',
      transition: 'var(--transition-smooth)',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    },

    pricingHeader: {
      fontSize: '1.5rem',
      marginBottom: '8px',
    },

    price: {
      fontSize: '2.5rem',
      fontFamily: 'var(--font-headings)',
      fontWeight: '700',
      marginBottom: '32px',
      display: 'flex',
      alignItems: 'flex-end',
      gap: '4px',
    },

    priceSpan: {
      fontSize: '1rem',
      color: '#a0a5b5',
      fontWeight: '400',
      marginBottom: '8px',
    },

    uiStyle: {
      listStyle: 'none'
    },

    liStyle: {
      position: 'relative',
      paddingLeft: '30px',
      marginBottom: '16px',
      color: '#fff',
      fontSize: '1rem',
      listStyle: 'none',
      display: 'flex',
      alignItems: 'center',
      // O seletor abaixo só funciona via propriedade SX do MUI
      '&::before': {
        content: '"✔"',
        position: 'absolute',
        left: 0,
        color: '#A5E13B',
        fontWeight: 'bold',
        fontSize: '1.2rem',
      },
    },

    button: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '10px',
      padding: '30px 10px',
      borderRadius: '50px',
      fontFamily: 'var(--font - headings)',
      fontWeight: '600',
      fontSize: '0.95rem',
      cursor: 'pointer',
      border: 'none',
      whiteSpace: 'nowrap',
      letterSpacing: '0.5px',
      textTransform: 'uppercase',
      transition: 'all var(--transition-smooth)',
    },

    btnOutline: {
      background: 'transparent',
      color: '#a0a5b5',
      border: '1px solid #ffffff55',

      '&:: hover': {
        borderColor: '#A5E13B',
        color: '#A5E13B',
        background: 'rgba(194, 233, 18, 0.05)',
        transform: 'translateY(-2px)',
      }
    },

    pricingCardPremium: {
      borderColor: '#A5E13B',
      boxShadow: '0 0 40px rgba(194, 233, 18, 0.1)',
      transform: 'scale(1.05)',
      background: '#151820',
      border: '1px solid #A5E13B',
      borderRadius: '24px',
      padding: '40px',
      transition: 'var(--transition-smooth)',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    },

    PricingBadge: {
      position: 'absolute',
      top: '0',
      left: '29%',
      transform: 'translate(-50 %, -50 %)',
      background: '#A5E13B',
      color: '#000',
      padding: '4px 16px',
      borderRadius: '20px',
      fontSize: '0.8rem',
      fontWeight: '700',
      textTransform: 'uppercase',
      marginTop: '-15px',
    },

    WhiteSpace: {
      height: '344px'
    },


    btnPrimary: {
      backgroundColor: '#A5E13B',
      color: '#000',
      boxShadow: '0 4px 20px #A5E13B',

      '&::hover': {
        backgroundColor: '#A5E13B',
        transform: 'translateY(-2px)',
        boxShadow: '0 8px 30px #A5E13B',
      }
    }
  }

  return (
    <Container id="OurPlans" sx={styles.pricing} >

      <Grid container sx={styles.container}>

        <Box sx={styles.sectionHeader}>
          <Typography component="h2" variant="h2" sx={styles.textGradient}>
            Nossos Planos
          </Typography>

          <Typography component="p" variant="p" sx={styles.sectionHeader}>
            Escolha a modalidade que melhor se adapta aos seus objetivos e bolso. Cancele a qualquer momento.
          </Typography>
        </Box>

        <Box sx={styles.pricingGrid}>
          <Box sx={styles.pricingCard}>
            <Box sx={styles.pricingHeader}>
              <Typography component="h4" variant="h4" sx={styles.textGradient}>
                Phorm Starter
              </Typography>

              <Typography component="p" variant="p" sx={styles.sectionHeader}>
                Ideal para quem quer começar a se movimentar com economia
              </Typography>
              <Box sx={styles.price}>
                <Typography component="h3" variant="h3" sx={styles.price}>
                  R$129,90
                  <Typography component="span" sx={styles.priceSpan}>
                    /Mês
                  </Typography>
                </Typography>
              </Box>
            </Box>
            <Box component="ul" sx={styles.uiStyle}>
              <Box component="li" sx={styles.liStyle}>Acesso a Rede de Parceiros Starter</Box>
              <Box component="li" sx={styles.liStyle}>App completo com rotinas de treino</Box>
              <Box component="li" sx={styles.liStyle}>Clube de Benefícios Básico</Box>
            </Box>
            <Button href="https://wa.me/55015988383050" sx={[styles.button, styles.btnOutline]}>
              assinar Start
            </Button>
          </Box>

          <Box sx={styles.pricingCardPremium}>
            <Box sx={styles.PricingBadge}>
              <Typography>Mais Popular</Typography>
            </Box>
            <Box sx={styles.pricingHeader}>

              <Typography component="h3" variant="h3" sx={styles.textGradient}>
                Phorm Pro
              </Typography>

              <Typography component="p" variant="p" sx={styles.sectionHeader}>
                O pacote completo para entusiastas que buscam resultados.
              </Typography>
            </Box>
            <Box sx={styles.price}>
              <Typography component="h3" variant="h3" sx={styles.price}>
                R$189,90
                <Typography component="span" sx={styles.priceSpan}>
                  /Mês
                </Typography>
              </Typography>
            </Box>

            <Box component="ul" sx={styles.uiStyle}>
              <Box component="li" sx={styles.liStyle}>Tudo do plano Starter MAIS Acesso aos parceiros PRO.</Box>
              <Box component="li" sx={styles.liStyle}>Clube de Benefícios Intermediário.</Box>
              <Box component="li" sx={styles.liStyle}>Acesso a Yoga, Pilates e Muito Mais.</Box>
            </Box>

            <Button href="https://wa.me/55015988383050" sx={[styles.button, styles.btnPrimary]}>
              PRO
            </Button>
          </Box>

          <Box sx={styles.pricingCard}>
            <Typography component="h3" variant="h3" sx={styles.textGradient}>
              Ver Mais Planos
            </Typography>

            <Typography component="p" variant="p" sx={styles.sectionHeader}>
              Baixe nosso App para descobrir mais planos e facilidades!
            </Typography>

            <Box sx={styles.WhiteSpace} />

            <Button href="https://wa.me/55015988383050" sx={[styles.button, styles.btnOutline]}>
              Ver Mais
            </Button>
          </Box>
        </Box>

      </Grid>
    </Container >
  );
}
